import { useSeoFormActions } from "@rf/property/module/components/property-form/store/slices/SeoFormSlice";
import { useValidateMinimalFieldRequired } from "./useValidateMinimalFieldRequired";
import useValidateSeoFieldHasValue from "./useValidateSeoFieldHasValue";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useValidateSeoRequiere } from "./useValidateSeoRequiere";

const useSeoDescriptionHelper = () => {
  const { validateMinimalRequiredField } = useValidateMinimalFieldRequired();
  const {
    generateDescription,
    isLoadingGenerateDescription,
    isLoadingTranslateSection
  } = useSeoFormActions();

  const { evaluateAndConfirmFieldReplacement: checkFields } =
    useValidateSeoFieldHasValue([
      CPropertyFormKeys.seo_description_en_property,
      CPropertyFormKeys.seo_description_es_property
    ]);
  const { validate } = useValidateSeoRequiere();

  const onValidateDescription = async () => {
    if (!validateMinimalRequiredField()) {
      return;
    }
    const _v = await validate();
    if (_v) {
      if (await checkFields()) {
        generateDescription();
      }
    }
  };

  return {
    generateDescription,
    onValidateDescription,
    isLoadingGenerateDescription,
    isLoadingTranslateSection
  };
};

export default useSeoDescriptionHelper;
